module.exports = __webpack_public_path__ + "img/main-building.6c47ba28.jpg";